import * as React from "react";
import type { SVGProps } from "react";
const SvgIconMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M376 443.72c0 27.48-60.27 39.78-120 39.78s-120-12.3-120-39.78c0-14.85 17.75-26.39 51.34-33.38l2.44-.51 3.76 18.03-2.45.51c-27.03 5.63-36.34 13.25-36.67 15.39 0 1.69 6.29 7.26 24.97 12.52 14.26 4.01 39.14 8.8 76.61 8.8s62.35-4.79 76.62-8.8c18.68-5.26 24.96-10.83 24.96-12.56-.32-2.1-9.63-9.72-36.66-15.35l-2.45-.51 3.75-18.03 2.45.51c33.58 6.99 51.33 18.53 51.33 33.38"
    />
    <path
      fill="#242323"
      d="M256.13 28.51h-1.98c-37.58 0-73.57 15.08-101.36 42.48-29.97 29.56-47.16 70.52-47.16 112.38 0 57.96 47.43 127.96 63.02 150.97 18 26.54 65.87 87.73 80.11 105.85l7.24 9.22 7.25-9.22c14.24-18.12 62.11-79.31 80.12-105.87 15.59-23.01 63.01-93.02 63.01-150.95 0-84.22-67.4-153.68-150.25-154.85Zm71.98 295.48c-15.41 22.74-54.14 72.61-72.11 95.58-17.97-22.97-56.69-72.84-72.12-95.59-14.8-21.85-59.83-88.35-59.83-140.62 0-36.96 15.19-73.14 41.67-99.26 24.33-23.98 55.73-37.19 88.43-37.19.57 0 1.15.01 1.72.02 72.83 1.02 132.09 62.23 132.09 136.43 0 52.27-45.03 118.76-59.85 140.63"
    />
  </svg>
);
export default SvgIconMap;
